import React from "react";
import { Link } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import { footerData } from "../../Data/data";
import { fontFamilyall, primaryColor, secondaryColor } from "../../UtilColorPalate/UtilColorPalate";
import { FooterLogo} from "../../Data/image"; // Import images separately


const Footer = () => {

    
    return (
        <footer
            style={{
                backgroundImage: "linear-gradient(to right, #222222, #444444, #222222)",
               fontFamily: fontFamilyall,
                padding: "60px 60px",
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
                marginTop: "60px",
            }}
        >
           <Grid container spacing={5} justifyContent="space-between">
    {/* Logo Section */}
    <Grid item xs={12} sm={6} md={2} textAlign="center">
        <img src={FooterLogo} alt="Logo" style={{ width: "100px", height: "auto" }} />
    </Grid>

    {/* Address Section */}
    <Grid item xs={12} sm={6} md={2}>
        <Typography variant="h6" color="white" fontWeight="bold" gutterBottom style={{fontFamily: fontFamilyall}}>
            Our Address
        </Typography>
        <Typography variant="body1" color="white" style={{fontFamily: fontFamilyall}}>{footerData.address.street}</Typography>
        <Typography variant="body1" color="white" style={{fontFamily: fontFamilyall}}>{footerData.address.city}</Typography>
        <Typography variant="body1" color="white" style={{fontFamily: fontFamilyall}}>{footerData.address.email}</Typography>
        <Typography variant="body1" color="white" style={{fontFamily: fontFamilyall}}>{footerData.address.phone}</Typography>
    </Grid>

    {/* Quick Links */}
    <Grid item xs={12} sm={6} md={2}>
        <Typography variant="h6" color="white" fontWeight="bold" gutterBottom style={{fontFamily: fontFamilyall}}>
            Quick Links
        </Typography>
        {footerData.quickLinks.map((link, index) => (
            <Link
                key={index}
                to={link.path}
                style={{
                    color: "white",
                    textDecoration: "none",
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "16px",
                    fontWeight: "500",
                    transition: "0.3s",
                    fontFamily: fontFamilyall
                }}
                onMouseEnter={(e) => (e.target.style.color = "#ff7eb3")}
                onMouseLeave={(e) => (e.target.style.color = "white")}
            >
                {link.label}
            </Link>
        ))}
    </Grid>

    {/* Contact Section */}
    <Grid item xs={12} sm={6} md={2}>
        <Typography variant="h6" color="white" fontWeight="bold" gutterBottom style={{fontFamily: fontFamilyall}}>
            Contact
        </Typography>
        <a
            href={footerData.contact.website}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                color: "white",
                textDecoration: "none",
                fontSize: "16px",
                fontWeight: "500",
                transition: "0.3s",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#ff7eb3")}
            onMouseLeave={(e) => (e.target.style.color = "white")}
        >
            {footerData.contact.website}
        </a>
        <Typography variant="body1" color="white" style={{fontFamily: fontFamilyall}}>{footerData.contact.email}</Typography>
        <Typography variant="body1" color="white" style={{fontFamily: fontFamilyall}}>{footerData.contact.phone}</Typography>
    </Grid>

    {/* Social Media */}
    <Grid item xs={12} sm={6} md={2} textAlign="center">
        <Typography variant="h6" color="white" fontWeight="bold" gutterBottom style={{fontFamily: fontFamilyall}}>
            Follow Us
        </Typography>
        <Box display="flex" justifyContent="center" gap={2}>
            {footerData.socialMedia.map((social, index) => (
                <a
                    key={index}
                    href={social.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                >
                    <social.icon
                        sx={{
                            color: "white",
                            fontSize: "35px",
                            cursor: "pointer",
                            transition: "0.3s",
                            "&:hover": { color: "#ff7eb3", transform: "scale(1.2)" },
                        }}
                    />
                </a>
            ))}
        </Box>
    </Grid>
</Grid>

            {/* Decorative Divider */}
            <Box
                sx={{
                    height: "2px",
                    background: "linear-gradient(to right, #ff7eb3, #ff4d4d)",
                    margin: "40px 0",
                }}
            />

            {/* Footer Bottom Section */}
            <Box mt={2} textAlign="center">
                <Typography variant="body2" color="white" sx={{ opacity: 0.7 }} style={{fontFamily: fontFamilyall}}>
                    Privacy Policy | Terms & Conditions | {footerData.copyRights}
                </Typography>
            </Box>
        </footer>
    );
};

export default Footer;
